import React from 'react'
import PropTypes from 'prop-types'
import { FullscreenModal } from 'belle-js'
import connectModal from 'connectModal'
import modalStyles from '../Modals.module.scss'

const GrantorInfoModal = (props) => {
  const {
    isOpen,
    closeModal,
    isActiveModal,
  } = props

  return (
    <FullscreenModal
      isOpen={isOpen}
      isActiveModal={isActiveModal}
      className={modalStyles.Modal}
      onClose={closeModal}
      testId="grantorInfoModal">
      <h2>
        What is a Grantor?
      </h2>

      <p>
        A grantor is an individual or other entity that creates a trust
        (i.e., the individual whose assets are put into the trust)
        regardless of whether the grantor also functions as the trustee.
        The grantor may also be referred to as the settlor, trustmaker, or trustor.
      </p>

      <div className={modalStyles.actions}>
        <button
          type="button"
          className="button button--primary"
          onClick={closeModal}>
          Close
        </button>
      </div>
    </FullscreenModal>
  )
}

GrantorInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  isActiveModal: PropTypes.bool.isRequired
}


export default connectModal(GrantorInfoModal, 'grantorInfoModal')



// WEBPACK FOOTER //
// ./src/components/Onboarding/Modals/GrantorInfoModal/GrantorInfoModal.jsx